import { render, staticRenderFns } from "./RemoteConsultation.vue?vue&type=template&id=583647c0&"
import script from "./RemoteConsultation.vue?vue&type=script&lang=js&"
export * from "./RemoteConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports